import { RESET_COPY } from '@eliadmin/core/src/components/dlz/auth/password-reset/password-reset-copy';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export type ResetStepNumber = 1 | 2 | 3;

/**
 * Figma „Steps“ (60155:20179): numbered dots joined by 32 px lines. Every step up to the current one
 * is red with a dark label (step 3 therefore shows all three that way), the rest grey. The lines
 * stay grey.
 */
export function ResetStepper({ current }: { current: ResetStepNumber }) {
  const { steps, label } = RESET_COPY.stepper;

  return (
    <ol aria-label={label} className="flex w-full items-center justify-center gap-2">
      {steps.map((name, index) => {
        const number = index + 1;
        const reached = number <= current;

        return (
          <li
            key={name}
            aria-current={number === current ? 'step' : undefined}
            className="flex items-center gap-1.5 whitespace-nowrap"
          >
            <span
              className={cn(
                'dlz-caption flex size-6 shrink-0 items-center justify-center rounded-full font-bold',
                reached ? 'bg-[#D7191F] text-white' : 'bg-[#E2E4E7] text-[#6B7079]',
              )}
            >
              <span className="dlz-trim">{number}</span>
            </span>
            <span
              className={cn(
                'dlz-caption dlz-trim shrink-0',
                reached ? 'text-[#0F1012]' : 'text-[#6B7079]',
              )}
            >
              {name}
            </span>
            {number < steps.length ? (
              <span
                aria-hidden="true"
                className="ml-0.5 h-px w-8 min-w-1 shrink bg-[#E2E4E7] max-[359px]:hidden"
              />
            ) : null}
          </li>
        );
      })}
    </ol>
  );
}
